module.exports = __webpack_public_path__ + "static/media/tcIMG.0bdc36b2.png";